import { ReactNode } from "react";
import { EuiTourStep } from "@inscopix/ideas-eui";

const PageIDs = {
  home: "home",
  profile: "profile",
  // organization pages
  organizationProjects: "organization-projects",
  organizationUsage: "organization-usage",
  organizationPeople: "organization-people",
  // project pages
  projectHome: "project-home",
  projectDataTable: "data-table",
  projectAnalysisTable: "analysis-table",
};

export type Page = keyof typeof PageIDs;

export const TourConditions = [
  "isOrgAdmin",
  "isProjectAdmin",
  "isProjectEditor",
  "canEditProject",
  "isPersonalSpace",
] as const;

export type TourConditionType = (typeof TourConditions)[number];

export type TourOptions = {
  dismissButton?: boolean;
};

export type Tour = {
  name: string;
  pages: Page[];
  conditions: Partial<Record<TourConditionType, boolean>>;
  options?: TourOptions;
  description: string;
  condition?: (props: Record<string, unknown>) => boolean;
  steps: {
    anchorId: string;
    title: string;
    content: ReactNode;
    props?: Partial<Omit<React.ComponentProps<typeof EuiTourStep>, "children">>;
  }[];
};
